import { render, staticRenderFns } from "./contactsEdit.vue?vue&type=template&id=1c5f5b70&scoped=true&"
import script from "./contactsEdit.vue?vue&type=script&lang=js&"
export * from "./contactsEdit.vue?vue&type=script&lang=js&"
import style0 from "./contactsEdit.vue?vue&type=style&index=0&id=1c5f5b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f5b70",
  null
  
)

export default component.exports